angular.module('st').controller('UptimeMetricsController', UptimeMetricsController);
//angular.module('st').push('ngAnimate');
UptimeMetricsController.$inject = ['$scope', '$rootScope', '$sce', '$filter', '$http', '$q', '$timeout', '$interval'];

function UptimeMetricsController($scope, $rootScope, $sce, $filter, $http, $q, $timeout, $interval) {
    var umc = this;

    // --- Constants ---
    const REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes in milliseconds
    // Update the constants
    umc.PING_THRESHOLDS = {
        good: 800,
        okay: 1500,
        bad: 3000,
        veryBad: Number.MAX_VALUE
    };
    umc.HEALTH_THRESHOLDS = { low: 99, medium: 95, high: 90 };
    umc.COLORS = {
        good: 'limegreen',
        okay: '#9bff00',  // A color between green and gold
        bad: '#FFD700',   // Original gold color
        veryBad: '#ff4500', // Original red color
        none: 'lightgray'
    };
    // --- Lookup Data ---
    //umc.VISTA_ENDPOINTS_KEY = [
    //    { "name": "Login", "endpoint": "RESTLoyalty.svc/member/validate", "chartid": "login" },
    //    { "name": "Gift Cards", "endpoint": "RESTData.svc/gift-cards/balance/90010069597767027132", "chartid": "giftcard" },
    //    { "name": "Cinemas", "endpoint": "OData.svc/Cinemas", "chartid": "cinemas" },
    //    { "name": "MFO Toggle", "endpoint": "https://api.celemonitor.com/api/mfoStatus", "chartid": "mfotoggle" }
    //];
    umc.VISTA_ENDPOINTS_KEY = [
        //Misc
        {
            "name": "MFO Toggle",
            "endpoint": "https://api.celemonitor.com/api/mfoStatus",
            "chartid": "mfotoggle",
            "server": "DMZ-DENETHOR",
            "description": "Toggle for MFO on Celemonitor - alters mfo status on on CO-GIMLI",
            "tags": ["mfo toggle"]
        },
        // Central Servers
        {
            "name": "Gift Cards",
            "endpoint": "RESTData.svc/gift-cards/balance/90010069597767027132",
            "chartid": "giftcard",
            "description": "Gift Cards & Vouchers Server - Handles balance checks on gift cards, validates vouchers",
            "server": "CO-MERRY",
            "tags": ["gift-cards", "vouchers"]
        },
        {
            "name": "Login",
            "endpoint": "RESTLoyalty.svc/member/validate",
            "chartid": "login",
            "description": "Loyalty Server - Handles loyalty point balances, loyalty logins, recognition rewards, loyalty tiers",
            "server": "CO-FRODO",
            "tags": ["loyalty", "points", "rewards"]
        },
        {
            "name": "CO-GS01",
            "endpoint": "OData.svc/giftstore",
            "chartid": "giftstore",
            "description": "Gift Store - Handles purchase/renewal of VIP subscription, purchase of gift cards & gold tickets",
            "server": "CO-GS01",
            "tags": ["vip", "subscriptions", "gift-cards"]
        },
        {
            "name": "CO-GIMLI",
            "endpoint": "payment-access-tokens/Braintree",
            "chartid": "braintree",
            "description": "Connect Server - Braintree tokens, relays info between cinema servers & website",
            "server": "CO-GIMLI",
            "tags": ["payments", "braintree"]
        },
        {
            "name": "Cinemas",
            "endpoint": "OData.svc/Cinemas",
            "chartid": "cinemas",
            "description": "API Host Server",
            "server": "DMZ-LEGOLAS",
            "tags": ["api"]
        },
        // Cinema Servers
        {
            "name": "AR-DB01",
            "endpoint": "orders?cinemaId=009",
            "chartid": "carousel",
            "description": "Cinema Carousel",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "BH-DB01",
            "endpoint": "orders?cinemaId=007",
            "chartid": "benton",
            "description": "Celebration Benton Harbor",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "CR-DB01",
            "endpoint": "orders?cinemaId=003",
            "chartid": "crossroads",
            "description": "Celebration Crossroads",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "GD-DB01",
            "endpoint": "orders?cinemaId=011",
            "chartid": "getty",
            "description": "Getty Drive-in",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "GN-DB01",
            "endpoint": "orders?cinemaId=002",
            "chartid": "grnorth",
            "description": "Celebration GR North",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "GS-DB01",
            "endpoint": "orders?cinemaId=004",
            "chartid": "grsouth",
            "description": "Celebration GR South",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "LA-DB01",
            "endpoint": "orders?cinemaId=006",
            "chartid": "lansing",
            "description": "Celebration Lansing",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "MP-DB01",
            "endpoint": "orders?cinemaId=008",
            "chartid": "mtpleasant",
            "description": "Celebration Mt Pleasant",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "MM-DB01",
            "endpoint": "orders?cinemaId=012",
            "chartid": "meridian",
            "description": "Studio C Meridian Mall",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "RT-DB01",
            "endpoint": "orders?cinemaId=005",
            "chartid": "rivertown",
            "description": "Celebration Rivertown",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "SP-DB01",
            "endpoint": "orders?cinemaId=013",
            "chartid": "studiopark",
            "description": "Celebration Studio Park",
            "tags": ["cinema", "bookings", "concessions"]
        }
    ];
    const BT_URL_KEYWORD_OLD = "/payment-access-tokens/Braintree";
    const BT_URL_KEYWORD = "payment-access-tokens/Braintree";
    const ORDERS_URL_KEYWORD = "orders?cinemaId";
    const SEATPLAN_URL_KEYWORD = "/screens/01/seat-plan";
    const SESSION_SEATPLAN_URL_KEYWORD = '/sessions/'; 

    const DAYS = 30;
    const CHARTS = {};

    // --- Data ---
    umc.btLast30Days = [];
    umc.nonBtLast30Days = [];
    umc.orderLast30Days = [];
    umc.seatPlanLast30Days = [];
    umc.metrics = [];
    umc.ping24Hours = null;
    umc.ping24HoursBT = null;
    umc.ping24HoursOrders = null;
    umc.ping24HoursSeatPlans = null;
    umc.last30DaysAllUniqueUnhealthyDetails = [];
    umc.selectedDate = null;
    umc.selectedEndpoint = null;
    umc.customSearchResults = null;
    umc.customModalSearching = false;
    // Add new properties
    umc.customStartDate = null;
    umc.customEndDate = null;
    umc.customEndpoint = null;
    umc.customRangeData = null;

    // --- Initialization ---
    umc.init = function () {
        startAutoRefresh();
    };

// Add this after your init function
function startAutoRefresh() {
    // Initial load
    dashBoardCharts();
    
    // Set up interval for refresh
    const intervalPromise = $interval(function() {
        umc.get24HourPings();
        umc.getBraintreeDailyHealthLast30Days();
        umc.getNonBraintreeDailyHealthLast30Days();
        umc.getOrdersDailyHealthLast30Days();
        umc.getSeatPlansDailyHealthLast30Days();
        umc.getSessionSeatPlansDailyHealthLast30Days();
    }, REFRESH_INTERVAL);

    // Clean up interval when scope is destroyed
    $scope.$on('$destroy', function() {
        if (intervalPromise) {
            $interval.cancel(intervalPromise);
        }
    });
}

function dashBoardCharts() {
    umc.get24HourPings();
    umc.getBraintreeDailyHealthLast30Days();
    umc.getNonBraintreeDailyHealthLast30Days();
    umc.getOrdersDailyHealthLast30Days();
    umc.getSeatPlansDailyHealthLast30Days();
    umc.getSessionSeatPlansDailyHealthLast30Days();
}

    // --- Helpers ---
    function createLast30DaysArray() {
        const daysArray = [];
        for (let i = DAYS - 1; i >= 0; i--) {
            const date = new Date();
            date.setDate(date.getDate() - i);
            date.setHours(0, 0, 0, 0);
            daysArray.push({
                date: date,
                item: { }
            });
        }
        return daysArray;
    }
    function getResponseTimeByDateAndEndpoint(date, endpointUrl) {
        var config = {
            params: {
                date: date.toISOString(),
                endpointUrl: endpointUrl
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/uptime/getResponseTimeByDateAndEndpoint", config)
            .then(deferred.resolve);
        return deferred.promise;
    }

    function buildAllUniqueUnhealthyDetailsArray() {
        function getDateKey(date) {
            try {
                return date.toISOString().slice(0, 10);
            } catch (err) {
                console.error(date, err);
            }
        }

        const allDays = {};
        [umc.btLast30Days, umc.nonBtLast30Days, umc.orderLast30Days, umc.seatPlanLast30Days].forEach((arr, index) => {
            arr.forEach(dayObj => {
                const key = getDateKey(dayObj.date);
                if (!allDays[key]) {
                    allDays[key] = {
                        date: dayObj.date,
                        details: [],
                        healthyPercentages: [],
                    };
                }
            });
        });

        // Add unique details from all arrays with category information
        const sources = [
            { array: umc.btLast30Days, category: 'Braintree Payment Tokens' },
            { array: umc.nonBtLast30Days, category: 'Other Services' },
            { array: umc.orderLast30Days, category: 'Orders' },
            { array: umc.seatPlanLast30Days, category: 'Seat Plans' },
            { array: umc.sessionSeatPlanLast30Days, category: 'Session Seat Plans' }
        ];

        sources.forEach(source => {
            source.array.forEach(dayObj => {
                const key = getDateKey(dayObj.date);
                if (dayObj.item.HealthyPercentage) {
                    allDays[key].healthyPercentages.push(dayObj.item.HealthyPercentage);
                }
                if (dayObj.item && dayObj.item.UnhealthyDetails) {
                    dayObj.item.UnhealthyDetails.split(' | ').forEach(msg => {
                        msg = msg.trim();
                        if (msg) {
                            // Create an object containing both message and category
                            const detail = {
                                message: msg,
                                category: source.category,
                                endpoint: dayObj.item.EndpointUrl // Include endpoint URL if available
                            };
                            // Check if this exact message+category combination already exists
                            const exists = allDays[key].details.some(d =>
                                d.message === detail.message &&
                                d.category === detail.category
                            );
                            if (!exists) {
                                allDays[key].details.push(detail);
                            }
                        }
                    });
                }
            });
        });

        Object.values(allDays).forEach(day => {
            day['labeldate'] = formatDayLabel(day.date);
        });

        umc.last30DaysAllUniqueUnhealthyDetails = Object.values(allDays)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    }

    function findGlobalMaxPing() {
        let maxPing = 0;

        // Check all data sources
        [umc.ping24Hours, umc.ping24HoursBT, umc.ping24HoursOrders, umc.ping24HoursSeatPlans].forEach(dataGroup => {
            if (!dataGroup) return;

            Object.values(dataGroup).forEach(pingSet => {
                const maxInSet = Math.max(...pingSet.map(obj => obj.AverageResponseTimeMs));
                maxPing = Math.max(maxPing, maxInSet);
            });
        });

        // Round up to nearest 500
        return Math.ceil(maxPing / 500) * 500;
    }

    // Call this after both AJAX calls complete
function tryBuildAllUniqueUnhealthyDetailsArray() {
    if (umc.btLast30Days.length && 
        umc.nonBtLast30Days.length && 
        umc.orderLast30Days.length && 
        umc.seatPlanLast30Days.length &&
        umc.sessionSeatPlanLast30Days.length) {
        buildAllUniqueUnhealthyDetailsArray();
    }
}

    function matchAndPopulateDays(daysArray, responseData) {
        daysArray.forEach(function (dayObj) {
            var match = responseData.find(function (dataObj) {
                var dayDate = dayObj.date;
                var dataDate = jsonDateToJSDate(dataObj.Day);
                return dayDate.getFullYear() === dataDate.getFullYear() &&
                    dayDate.getMonth() === dataDate.getMonth() &&
                    dayDate.getDate() === dataDate.getDate();
            });
            if (match) {
                dayObj.item.checked = match.checked !== undefined ? match.checked : dayObj.item.checked;
                dayObj.item.healthy = match.healthy !== undefined ? match.healthy : dayObj.item.healthy;
                dayObj.item.HealthyPercentage = match.HealthyPercentage !== undefined ? match.HealthyPercentage : dayObj.item.HealthyPercentage;
                dayObj.item.AverageResponseTimeMs = match.AverageResponseTimeMs !== undefined ? match.AverageResponseTimeMs : dayObj.item.AverageResponseTimeMs;
                dayObj.item.UnhealthyDetails = match.UnhealthyDetails !== undefined ? match.UnhealthyDetails : dayObj.item.UnhealthyDetails;
                dayObj.data = true;
            } else {
                dayObj.data = false;
            }
        });
    }

    function jsonDateToJSDate(datestr) {
        const milliseconds = parseInt(datestr.match(/\d+/)[0], 10);
        return new Date(milliseconds);
    }

    function formatDayLabel(date) {
        const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
        const day = date.getDate();
        const ordinal = day + (day % 10 == 1 && day != 11 ? 'st' :
            day % 10 == 2 && day != 12 ? 'nd' :
                day % 10 == 3 && day != 13 ? 'rd' : 'th');
        return months[date.getMonth()] + ' ' + ordinal;
    }

    // --- API Calls ---
    function getSessionSeatPlansDailyHealthLast30Days() {
        $http.get("/rpc/uptime/getSessionSeatPlansDailyHealthLast30DaysAsync").then(function (response) {
            umc.sessionSeatPlanLast30Days = createLast30DaysArray();
            if (response && response.data) {
                matchAndPopulateDays(umc.sessionSeatPlanLast30Days, response.data);
            }
            $timeout(function () {
                render30DaysChart('sessionseatplan30days', umc.sessionSeatPlanLast30Days);
                tryBuildAllUniqueUnhealthyDetailsArray();
            }, 1000);
        });
    }

    function getBraintreeDailyHealthLast30Days() {
        $http.get("/rpc/uptime/getBraintreeDailyHealthLast30DaysAsync").then(function (response) {
            umc.btLast30Days = createLast30DaysArray();
            if (response && response.data) {
                matchAndPopulateDays(umc.btLast30Days, response.data);
            }
            $timeout(function () {
                render30DaysChart('bt30days', umc.btLast30Days);
                tryBuildAllUniqueUnhealthyDetailsArray();
            }, 1000);
        });
    }   
    function getNonBraintreeDailyHealthLast30Days() {
        $http.get("/rpc/uptime/getNonBraintreeDailyHealthLast30DaysAsync").then(function (response) {
            umc.nonBtLast30Days = createLast30DaysArray();
            if (response && response.data) {
                matchAndPopulateDays(umc.nonBtLast30Days, response.data);
            }
            $timeout(function () {
                render30DaysChart('vista30days', umc.nonBtLast30Days);
                tryBuildAllUniqueUnhealthyDetailsArray();
            }, 1000);
        });
    }
    // Add new API functions
function getOrdersDailyHealthLast30Days() {
    $http.get("/rpc/uptime/getOrdersDailyHealthLast30DaysAsync").then(function (response) {
        umc.orderLast30Days = createLast30DaysArray();
        if (response && response.data) {
            matchAndPopulateDays(umc.orderLast30Days, response.data);
        }
        $timeout(function () {
            render30DaysChart('orders30days', umc.orderLast30Days);
            tryBuildAllUniqueUnhealthyDetailsArray();
        }, 1000);
    });
}

function getSeatPlansDailyHealthLast30Days() {
    $http.get("/rpc/uptime/getSeatPlansDailyHealthLast30DaysAsync").then(function (response) {
        umc.seatPlanLast30Days = createLast30DaysArray();
        if (response && response.data) {
            matchAndPopulateDays(umc.seatPlanLast30Days, response.data);
        }
        $timeout(function () {
            render30DaysChart('seatplan30days', umc.seatPlanLast30Days);
            tryBuildAllUniqueUnhealthyDetailsArray();
        }, 1000);
    });
}

    //temp function to be removed later
function normalizeBTUrls(data) {
    return data.map(item => {
        // Create a new object to avoid modifying the original
        let normalizedItem = { ...item };
        
        // Check if URL starts with / and contains BT_URL_KEYWORD or BT_URL_KEYWORD_OLD
        if (normalizedItem.EndpointUrl.startsWith('/') && 
            (normalizedItem.EndpointUrl.includes(BT_URL_KEYWORD) || 
             normalizedItem.EndpointUrl.includes(BT_URL_KEYWORD_OLD))) {
            // Remove leading slash
            normalizedItem.EndpointUrl = normalizedItem.EndpointUrl.substring(1);
        }
        return normalizedItem;
    });
}
    function get24HourPings() {
        $http.get("/rpc/uptime/averageResponseTime24Hours").then(function (response) {
                if (response && response.data) {
            const filteredDataBT = response.data.filter(obj => obj.EndpointUrl.includes(BT_URL_KEYWORD) || obj.EndpointUrl.includes(BT_URL_KEYWORD_OLD));
            const filteredDataOrders = response.data.filter(obj => obj.EndpointUrl.includes(ORDERS_URL_KEYWORD));
                    const filteredDataSeatPlans = response.data.filter(obj => obj.EndpointUrl.includes(SEATPLAN_URL_KEYWORD));
                    const filteredDataSessionSeatPlans = response.data.filter(obj =>
                        obj.EndpointUrl.includes(SESSION_SEATPLAN_URL_KEYWORD) &&
                        obj.EndpointUrl.includes('seat-plan')
                    );
            const filteredDataOther = response.data.filter(obj => 
                !obj.EndpointUrl.includes(BT_URL_KEYWORD) &&
                !obj.EndpointUrl.includes(BT_URL_KEYWORD_OLD) &&
                !obj.EndpointUrl.includes(ORDERS_URL_KEYWORD) &&
                !obj.EndpointUrl.includes(SEATPLAN_URL_KEYWORD) &&
                !(obj.EndpointUrl.includes(SESSION_SEATPLAN_URL_KEYWORD) &&
                    obj.EndpointUrl.includes('seat-plan'))
            );

            //old BT fix
            
            
                        // Normalize BT URLs before grouping
            const normalizedBTData = normalizeBTUrls(filteredDataBT);
            
            umc.ping24HoursBT = groupAndSortByUrl(normalizedBTData)
            umc.ping24HoursOrders = groupAndSortByUrl(filteredDataOrders);
            umc.ping24HoursSeatPlans = groupAndSortByUrl(filteredDataSeatPlans);
            umc.ping24Hours = groupAndSortByUrl(filteredDataOther);
            umc.ping24HoursSessionSeatPlans = groupAndSortByUrl(filteredDataSessionSeatPlans);



                    angular.forEach(umc.ping24HoursBT, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
                    angular.forEach(umc.ping24HoursOrders, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
            angular.forEach(umc.ping24HoursSessionSeatPlans, function (value, key) {
                //show last value vesrus average for current ping status and color
                //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
                    angular.forEach(umc.ping24HoursSeatPlans, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
                    angular.forEach(umc.ping24Hours, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });

                    // Update loading states
                    umc.isLoading.braintree = false;
                    umc.isLoading.orders = false;
                    umc.isLoading.seatplans = false;
                    umc.isLoading.other = false;
                    umc.isLoading.sessionSeatplans = false;
        } else {
            umc.ping24Hours = null;
            umc.ping24HoursBT = null;
            umc.ping24HoursOrders = null;
            umc.ping24HoursSeatPlans = null;
        }
            $timeout(function () {
                render24HoursCharts();
            }, 1000);
        });
    }

function groupAndSortByUrl(data) {
    // First, normalize the data to handle session-based URLs
    const normalizedData = data.map(item => {
        let normalizedUrl = item.EndpointUrl;
        
        // If it's a session seat plan URL, normalize it to group by cinema only
        const sessionMatch = normalizedUrl.match(/RESTData\.svc\/cinemas\/(\d+)\/sessions\/[^\/]+\/seat-plan/i);
        if (sessionMatch) {
            const cinemaId = sessionMatch[1];
            normalizedUrl = `RESTData.svc/cinemas/${cinemaId}/sessions/[session]/seat-plan`;
        }
        
        return {
            ...item,
            NormalizedEndpointUrl: normalizedUrl,
            OriginalEndpointUrl: item.EndpointUrl
        };
    });
    
    // Group by normalized URL instead of actual URL
    let grouped = Object.groupBy(normalizedData, (item) => item.NormalizedEndpointUrl);
    
    // Sort each group by time
    for (const url in grouped) {
        grouped[url].sort((a, b) => jsonDateToJSDate(a.Hour) - jsonDateToJSDate(b.Hour));
    }
    
    return grouped;
}

    // --- Chart Rendering ---
    function render30DaysChart(elementId, daysArray) {
        var ctx = null;
        try {
            ctx = document.getElementById(elementId);
        } catch (err) {
            console.error(elementId, err);
        }
        //const ctx = document.getElementById(elementId);
        const thresholdRed = umc.HEALTH_THRESHOLDS.high;
        const thresholdYellow = umc.HEALTH_THRESHOLDS.medium;
        const labels = daysArray.map(obj => formatDayLabel(obj.date));
        const dayBars = new Array(DAYS).fill(1);

        //old way was checking by average ping, changed to check by HealthyPercentage.
        //const pings = daysArray.map(obj => obj.item.AverageResponseTimeMs ? Math.round(obj.item.AverageResponseTimeMs) : undefined);
        //const backgroundColors = pings.map(function (value) {
        //    if (value == undefined) return 'lightgray';
        //    if (value >= thresholdRed) return 'red';
        //    if (value >= thresholdYellow) return 'yellow';
        //    return 'green';
        //});
        const healthPercentage = daysArray.map(obj => obj.item.HealthyPercentage ? Math.round(obj.item.HealthyPercentage) : undefined);
        //const backgroundColors = healthPercentage.map(function (value) {
        //    if (value == undefined) return umc.COLORS.none;
        //    if (value <= thresholdRed) return umc.COLORS.error;
        //    if (value <= thresholdYellow) return umc.COLORS.warning;
        //    return umc.COLORS.good;
        //});
        const backgroundColors = healthPercentage.map(function (value) {
            if (value == undefined) return umc.COLORS.none;
            if (value <= thresholdRed) return umc.COLORS.veryBad;      // Changed from error
            if (value <= thresholdYellow) return umc.COLORS.bad;       // Changed from warning
            return umc.COLORS.good;                                    // Kept as good
        });

        const data = {
            labels: labels,
            datasets: [{
                label: 'Avg Response Time (ms)',
                data: dayBars,
                backgroundColor: backgroundColors,
                borderColor: backgroundColors
            }]
        };
        const config = {
            type: 'bar',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                var txt = healthPercentage[context.dataIndex] ? healthPercentage[context.dataIndex] + "% uptime" : 'no data';
                                return txt;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: { drawBorder: false, display: false },
                        ticks: { color: 'white', display: false },
                        border: { display: false }
                    },
                    y: {
                        min: 0, max: 1, beginAtZero: true,
                        grid: { drawBorder: false, display: false },
                        ticks: { stepSize: 200, color: 'white', display: false },
                        border: { display: false }
                    }
                },
                layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } }
            }
        };

    if (CHARTS[elementId]) {
        // Update existing chart
        CHARTS[elementId].data = data;
        CHARTS[elementId].options = config.options;
        CHARTS[elementId].update(); // 'none' for no animation on update
    } else {
        // Create new chart
        CHARTS[elementId] = new Chart(ctx, config);
    }

    }
    // Add new function to get custom range data
    umc.getCustomRangeData = function () {
        if (!umc.customStartDate || !umc.customEndDate) return;

        umc.customModalSearching = true;

        var config = {
            params: {
                startDate: new Date(umc.customStartDate).toISOString(),
                endDate: new Date(umc.customEndDate).toISOString(),
                endpointUrl: umc.customEndpoint || null
            }
        };

        $http.get("/rpc/uptime/getResponseTimeByDateRange", config)
            .then(function (response) {
                var sortedData = response.data.sort((a, b) =>
                    jsonDateToJSDate(a.Hour) - jsonDateToJSDate(b.Hour)
                );

                umc.customRangeData = sortedData;

                $timeout(function () {
                    createCustomRangeChart('custom-range-chart',
                        sortedData.map(d => formatCustomRangeTime(jsonDateToJSDate(d.Hour))),
                        sortedData.map(d => Math.round(d.AverageResponseTimeMs))
                    );
                }, 100);
            })
            .finally(function () {
                umc.customModalSearching = false;
            });
    };
    function generate24HourPlaceholder() {
        const data = [];
        const now = new Date();
        for (let i = 23; i >= 0; i--) {
            data.push({
                EndpointUrl: '',
                Hour: new Date(now.getTime() - (i * 3600000)),
                AverageResponseTimeMs: 500 // Default placeholder value
            });
        }
        return data;
    }

    function generatePlaceholderGroup(count) {
        const placeholderGroup = {};
        for (let i = 1; i <= count; i++) {
            placeholderGroup[`placeholder-${i}`] = generate24HourPlaceholder();
        }
        return placeholderGroup;
    }

    // Initialize with placeholder data
    umc.ping24HoursBT = generatePlaceholderGroup(11);
    umc.ping24HoursOrders = generatePlaceholderGroup(11);
    umc.ping24HoursSeatPlans = generatePlaceholderGroup(10);
    umc.ping24Hours = generatePlaceholderGroup(4);
    umc.ping24HoursSessionSeatPlans = generatePlaceholderGroup(10);

    // Add loading states
    umc.isLoading = {
        braintree: true,
        orders: true,
        seatplans: true,
        sessionSeatplans: true,
        other: true
    };
    // Add helper function for date/time formatting
    function formatCustomRangeTime(dateObject) {
        return $filter('date')(dateObject, 'MMM d, h:mm a');
    }
    // Modified chart creation for custom range
   
    function createCustomRangeChart(elmId, labels, pings) {
        var ctx = document.getElementById(elmId);
        const MAX_DISPLAY_PING = 15000;

        // Store original values for tooltips
        const originalPings = [...pings];

        // Transform pings for display
        const displayPings = pings.map(ping => {
            if (ping === 0 || ping === -1) return MAX_DISPLAY_PING - 1;
            return Math.min(ping, MAX_DISPLAY_PING - 1);
        });

        // Calculate dynamic max
        const maxDisplayValue = Math.max(...displayPings);
        const dynamicMax = Math.min(
            Math.max(3000, Math.ceil(maxDisplayValue / 1000) * 1000),
            MAX_DISPLAY_PING
        );

        const data = {
            labels: labels,
            datasets: [{
                label: 'Response Time (ms)',
                data: displayPings,
                fill: false,
                borderColor: 'rgb(224, 60, 49)',
                tension: 0.1,
                pointRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Make capped values larger and more visible
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 4;
                    }
                    return 0.5;
                },
                pointHoverRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 8;
                    }
                    return 7;
                },
                pointBackgroundColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderWidth: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 2;
                    }
                    return 1;
                },
                segment: {
                    borderColor: function (context) {
                        const originalValue = originalPings[context.p1DataIndex];
                        if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                        if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                        if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                        if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                        return umc.COLORS.veryBad;
                    }
                }
            }]
        };

        const config = {
            type: 'line',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            label: function (tooltipItem) {
                                const originalValue = originalPings[tooltipItem.dataIndex];

                                if (originalValue === 0 || originalValue === -1) {
                                    return `Server Error @ ${tooltipItem.label}`;
                                }

                                const formattedValue = originalValue.toLocaleString();
                                return `${formattedValue} ms @ ${tooltipItem.label}`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            maxRotation: 45,
                            minRotation: 45,
                            autoSkip: true,
                            maxTicksLimit: 20
                        }
                    },
                    y: {
                        min: 0,
                        max: dynamicMax,
                        beginAtZero: true,
                        ticks: {
                            stepSize: Math.max(500, Math.floor(dynamicMax / 10)),
                            callback: function (value) {
                                return value.toLocaleString();
                            }
                        }
                    }
                }
            }
        };

        if (CHARTS[elmId]) {
            CHARTS[elmId].destroy();
        }
        CHARTS[elmId] = new Chart(ctx, config);
    }

    function render24HoursCharts() {
        if (!umc.isLoading.braintree) {
            render24HoursChart(umc.ping24Hours, umc.btvistaendpoint, 'btpings-');
        }
        if (!umc.isLoading.orders) {
            render24HoursChart(umc.ping24HoursBT, umc.btvistacinema, 'btpings-');
        }
        if (!umc.isLoading.seatplans) {
            render24HoursChart(umc.ping24HoursOrders, umc.btvistacinema, 'orderpings-');
        }
        if (!umc.isLoading.sessionSeatplans) {
            render24HoursChart(umc.ping24HoursSessionSeatPlans, umc.btvistacinema, 'sessionseatpings-');
        }
        if (!umc.isLoading.other) {
            render24HoursChart(umc.ping24HoursSeatPlans, umc.btvistacinema, 'seatpings-');
        }
    }

    function render24HoursChart(groupedData, endpointLookupFn, chartIdPrefix) {
        if (!groupedData) return;
        for (const key in groupedData) {
            let loc = groupedData[key];
            let locid = endpointLookupFn(loc[0].EndpointUrl).chartid || endpointLookupFn(loc[0].EndpointUrl).id;
            var pings = loc.map(obj => Math.round(obj.AverageResponseTimeMs));
            var hours = loc.map(obj => {
                const dateObject = jsonDateToJSDate(obj.Hour);
                return format24HourTime(dateObject, true);
                //const hours24 = dateObject.getHours();
                //let ampm = hours24 >= 12 ? 'PM' : 'AM';
                //let hours12 = hours24 % 12;
                //hours12 = hours12 ? hours12 : 12;
                //return hours12 + " " + ampm;
            });
            let chartid = chartIdPrefix + locid;
            //console.log('before ping', groupedData);
            createPingChart(chartid, hours, pings, false);
        }
    }

    function createPingChart(elmId, labels, pings, destroy) {
        var ctx = null;
        try {
            ctx = document.getElementById(elmId);
        } catch (err) {
            console.error(elmId, err);
        }

        var thresholdRed = umc.PING_THRESHOLDS.high;
        var thresholdYellow = umc.PING_THRESHOLDS.medium;
        const MAX_DISPLAY_PING = 15000;
        const MAX_DISPLAY_PING_VALUE = 14500;

        // Store original values for tooltips
        const originalPings = [...pings];

        // Transform pings for display: cap at MAX_DISPLAY_PING, treat 0/-1 as errors
        const displayPings = pings.map(ping => {
            if (ping === 0 || ping === -1) return MAX_DISPLAY_PING_VALUE; // Show errors just below max (14999)
            return Math.min(ping, MAX_DISPLAY_PING_VALUE); // Cap outliers at 14999
        });

        // Calculate dynamic max: use the highest display value, rounded up to nearest 1000, but cap at MAX_DISPLAY_PING
        const maxDisplayValue = Math.max(...displayPings);
        const dynamicMax = Math.min(
            Math.max(3000, Math.ceil(maxDisplayValue / 1000) * 1000), // At least 3000, round up to nearest 1000
            MAX_DISPLAY_PING
        );

        const data = {
            labels: labels,
            datasets: [{
                label: 'response time (ms) ',
                data: displayPings,
                fill: false,
                borderColor: 'rgb(224, 60, 49)',
                tension: 0.1,
                pointRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Make capped values larger and more visible
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 4; // Larger dot for capped/error values
                    }
                    return 0.5; // Normal size
                },
                pointHoverRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Larger hover radius for capped values
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 8;
                    }
                    return 7;
                },
                pointBackgroundColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Server errors
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    // Normal thresholds
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Server errors
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    // Normal thresholds
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderWidth: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Thicker border for capped values
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 2;
                    }
                    return 1;
                },
                segment: {
                    borderColor: function (context) {
                        const originalValue = originalPings[context.p1DataIndex];
                        // Server errors
                        if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                        // Normal thresholds
                        if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                        if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                        if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                        return umc.COLORS.veryBad;
                    }
                }
            }]
        };

        const config = {
            type: 'line',
            data: data,
            stepped: true,
            options: {
                elements: { point: { radius: 1 } },
                responsive: true,
                plugins: {
                    title: { display: false, text: '' },
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        displayColors: false,
                        callbacks: {
                            title: function (context) { return ''; },
                            label: function (tooltipItem) {
                                const originalValue = originalPings[tooltipItem.dataIndex];

                                // Check for server errors
                                if (originalValue === 0 || originalValue === -1) {
                                    return `Server Error @ ${tooltipItem.label}`;
                                }

                                // Show actual value even if capped on display
                                const formattedValue = originalValue.toLocaleString();
                                return `${formattedValue} ms @ ${tooltipItem.label}`;
                            }
                        }
                    },
                    hover: {
                        mode: 'index',
                        intersect: false
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            font: { size: 8 },
                            color: 'white',
                            autoSkip: false,
                            callback: function (val, index, ticks) {
                                var ogLabel = this.getLabelForValue(val);
                                var ogLabels = ogLabel.split(' ').slice(1);
                                ogLabel = ogLabels.join(" ");
                                return (index === ticks.length - 1 || index % 4 === 0) ? ogLabel : '';
                            }
                        },
                    },
                    y: {
                        min: 0,
                        max: dynamicMax,
                        beginAtZero: true,
                        grid: { display: false },
                        ticks: {
                            stepSize: Math.max(500, Math.floor(dynamicMax / 10)),
                            color: 'white',
                            font: { size: 10 },
                            callback: function (value) {
                                return value.toLocaleString();
                            }
                        }
                    }
                }
            }
        };

        if (CHARTS[elmId]) {
            if (destroy) {
                CHARTS[elmId].destroy();
                CHARTS[elmId] = new Chart(ctx, config);
            } else {
                CHARTS[elmId].data = data;
                CHARTS[elmId].options = config.options;
                CHARTS[elmId].update('none');
            }
        } else {
            CHARTS[elmId] = new Chart(ctx, config);
        }
    }

    // --- Utility Functions ---
    umc.averageNumber = function (array, propertyname) {
        let numbers = array.map(obj => obj[propertyname]);
        if (numbers.length === 0) return 0;
        const sum = numbers.reduce((acc, val) => acc + val, 0);
        return Math.round(sum / numbers.length);
    };
    umc.getPingColor = function (pingValue) {
        // Handle error values first
        if (pingValue === 0 || pingValue === -1) {
            return 'veryBad';
        }

        if (pingValue <= umc.PING_THRESHOLDS.good) {
            return 'good';
        } else if (pingValue <= umc.PING_THRESHOLDS.okay) {
            return 'okay';
        } else if (pingValue <= umc.PING_THRESHOLDS.bad) {
            return 'bad';
        } else {
            return 'veryBad';
        }
    }   
    //umc.getDayColor = function (percentages) {
    //    const smallestPercentage = Math.min(...percentages);
    //    var colorClass = 'low';
    //    if (smallestPercentage >= umc.HEALTH_THRESHOLDS.low) {
    //        return 'low';
    //    } else if (smallestPercentage >= umc.HEALTH_THRESHOLDS.medium) {
    //        return 'medium';
    //    } else {
    //        return 'high';
    //    }
    //}
    umc.getDayColor = function (percentages) {
        const smallestPercentage = Math.round(Math.min(...percentages));

        if (smallestPercentage <= umc.HEALTH_THRESHOLDS.high) {      // <= 90
            return 'veryBad';   // Changed from 'high'
        } else if (smallestPercentage <= umc.HEALTH_THRESHOLDS.medium) { // <= 95
            return 'bad';       // Changed from 'medium'
        } else if (smallestPercentage <= umc.HEALTH_THRESHOLDS.low) {   // <= 99
            return 'okay';      // New middle tier
        } else {
            return 'good';      // Changed from 'low'
        }
    }
    function simpleStringHash(str) {
  let hash = 0;
  if (str.length === 0) return hash;

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char; // A common pattern for mixing bits
    hash = hash & hash; // Converts to 32-bit integer
  }
  return hash;
}
function format24HourTime(dateObject, includeDay) {
        const day = dateObject.getDate();

        const ordinal = day + (
            day % 10 == 1 && day != 11 ? 'st' :
            day % 10 == 2 && day != 12 ? 'nd' :
            day % 10 == 3 && day != 13 ? 'rd' : 'th'
        );
        
        const hours24 = dateObject.getHours();
        let ampm = hours24 >= 12 ? 'PM' : 'AM';
        let hours12 = hours24 % 12;
        hours12 = hours12 ? hours12 : 12;

        if (includeDay) {
            return ordinal + ' ' + hours12 + " " + ampm;
        } else {
            return hours12 + " " + ampm;
        }
    }

    //umc.getCustomResponseTime = function () {
    //    umc.customModalSearching = true;
    //    if (!umc.selectedDate || !umc.selectedEndpoint) return;
    //    let fixedDate = umc.selectedDate + "T00:00:00";
    //    getResponseTimeByDateAndEndpoint(new Date(fixedDate), umc.selectedEndpoint)
    //        .then(function (response) {    

    //            var sortedData = response.data.sort((a, b) => 
    //                jsonDateToJSDate(a.Hour) - jsonDateToJSDate(b.Hour)
    //            );

    //            umc.customSearchResults = sortedData;

    //            //$('#custom-ping-modal').modal({ show: true, backdrop: 'static', keyboard: false });

    //            // Wait for DOM to be ready
    //            $timeout(function () {
    //                createPingChart('custom-search-chart',
    //                    sortedData.map(d => format24HourTime(jsonDateToJSDate(d.Hour), true)), // Format hours
    //                    sortedData.map(d => Math.round(d.AverageResponseTimeMs)),      // Get response times
    //                    true //destroy chart
    //                );
    //            }, 100);
    //        })
    //        .finally(function(response) {umc.customModalSearching = false;});
    //};

    // --- API Wrappers for Angular ---
    umc.getBraintreeDailyHealthLast30Days = getBraintreeDailyHealthLast30Days;
    umc.getNonBraintreeDailyHealthLast30Days = getNonBraintreeDailyHealthLast30Days;
    umc.getOrdersDailyHealthLast30Days = getOrdersDailyHealthLast30Days;
    umc.getSeatPlansDailyHealthLast30Days = getSeatPlansDailyHealthLast30Days;
    umc.getSessionSeatPlansDailyHealthLast30Days = getSessionSeatPlansDailyHealthLast30Days;
    umc.get24HourPings = get24HourPings;

    // --- Lookup Data ---
    //umc.VISTA_ENDPOINTS_KEY = [
    //    { "name": "Login", "endpoint": "RESTLoyalty.svc/member/validate", "chartid": "login" },
    //    { "name": "Gift Cards", "endpoint": "RESTData.svc/gift-cards/balance/90010069597767027132", "chartid": "giftcard" },
    //    { "name": "Cinemas", "endpoint": "OData.svc/Cinemas", "chartid": "cinemas" },
    //    { "name": "MFO Toggle", "endpoint": "https://api.celemonitor.com/api/mfoStatus", "chartid": "mfotoggle" }
    //];
    umc.CINEMA_KEY = [
        { "id": "001", "name": "", "enabled": false },
        {
            "id": "009",
            "name": "Carousel",
            "enabled": true,
            "server": "AR-DB01",
            "description": "Cinema Carousel - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "007",
            "name": "Benton",
            "enabled": true,
            "server": "BH-DB01",
            "description": "Celebration Benton Harbor - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "003",
            "name": "Crossroads",
            "enabled": true,
            "server": "CR-DB01",
            "description": "Celebration Crossroads - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "011",
            "name": "Getty",
            "enabled": true,
            "server": "GD-DB01",
            "description": "Getty Drive-in - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "002",
            "name": "GR North",
            "enabled": true,
            "server": "GN-DB01",
            "description": "Celebration GR North - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "004",
            "name": "GR South",
            "enabled": true,
            "server": "GS-DB01",
            "description": "Celebration GR South - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "006",
            "name": "Lansing",
            "enabled": true,
            "server": "LA-DB01",
            "description": "Celebration Lansing - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "008",
            "name": "Mt Pleasant",
            "enabled": true,
            "server": "MP-DB01",
            "description": "Celebration Mt Pleasant - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "012",
            "name": "Meridian Mall",
            "enabled": true,
            "server": "MM-DB01",
            "description": "Studio C Meridian Mall - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "005",
            "name": "Rivertown",
            "enabled": true,
            "server": "RT-DB01",
            "description": "Celebration Rivertown - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "013",
            "name": "Studio Park/MT",
            "enabled": true,
            "server": "SP-DB01",
            "description": "Celebration Studio Park - Handles Bookings / serves up seat map / concession orders"
        },
        { "id": "010", "name": "", "enabled": false },
        {
            "id": "999",
            "name": "Gift Store",
            "enabled": true,
            "server": "CO-GS01",
            "description": "Gift Store Server"
        }
    ];

    // --- Lookup Functions ---
    umc.btvistaendpoint = function (endpointUrl) {
        //const found = umc.VISTA_ENDPOINTS_KEY.find(item => endpointUrl === String(item.endpoint));
        const found = umc.VISTA_ENDPOINTS_KEY.find(item => endpointUrl.includes(String(item.endpoint)));
        return found || '';
    };
umc.btvistacinema = function (endpointUrl) {
    // Handle normalized session URLs
    const sessionMatch = endpointUrl.match(/cinemas\/(\d+)\/sessions/i);
    if (sessionMatch) {
        const cinemaId = sessionMatch[1];
        const found = umc.CINEMA_KEY.find(item => item.id === cinemaId);
        return found || '';
    }
    
    // Original logic for other URLs
    const found = umc.CINEMA_KEY.find(item => endpointUrl.includes(String(item.id)));
    return found || '';
};
}